import pubsub from 'sweet-pubsub';
import { AmplitudeLogger, EVENTS } from "./utils";

export const useCti = (functions) => {
    // const defaultSize = { width: 400, height: 629 };

    // const { functions = {}} = window.PressOne
    const {
        onLogin,
        onNumberSelected,
        onCallInitiated,
        onCallStarted,
        onInComingCall,
        onCallEnded,
        onLogout
    } = functions || {}

    let phoneNumber = null;

    pubsub.on('login', ({mobile, email, first_name, last_name}) => {
        if ( phoneNumber ) {
            AmplitudeLogger.log(EVENTS.LOGIN, {mobile, email, first_name, last_name});
            pubsub.emit('initiate_call', phoneNumber);
        }
        if ( onLogin && typeof onLogin === "function" ) {
            eval(`(${decodeURI(onLogin)})(${JSON.stringify({mobile, email, first_name, last_name})})`)
        }
    });

    pubsub.on('number_selected', (number) => {
        AmplitudeLogger.log(EVENTS.NUMBER_SELECTED, {number});
        if ( phoneNumber ) {
            pubsub.emit('initiate_call', phoneNumber);
        }
        if ( onNumberSelected && typeof onNumberSelected === "function" ) {
            // onNumberSelected(number)
            eval(`(${decodeURI(onNumberSelected)})(${number})`)
        }
    })

    pubsub.on('call_started', ({direction, peer}) => {
        const timeStamp = Date.now();
        const payload = {
            timeStamp,
            direction,
            mobile: peer,
            duration: 0,
            notes: ""
        }
        if ( phoneNumber ) {
            payload.mobile = phoneNumber;
        }
        AmplitudeLogger.log(EVENTS.CALL_STARTED, payload);
        if ( onCallStarted && typeof onCallStarted === "function" ) {
            // onCallStarted(payload)
            eval(`(${decodeURI(onCallStarted)})(${JSON.stringify(payload)})`)
        }
    });

    pubsub.on('call_ended', ({direction, peer, duration, notes}) => {
        AmplitudeLogger.log(EVENTS.CALL_ENDED, {direction, peer, duration, notes});
        if ( onCallEnded && typeof onCallEnded === "function" ) {
            const timeStamp = Date.now();
            const payload = {
                timeStamp,
                direction, 
                mobile: peer,
                duration, 
                notes,
                downloadUrl: ""
            }
            // onCallEnded({direction, peer, duration, notes})
            eval(`(${decodeURI(onCallEnded)})(${JSON.stringify(payload)})`)
        }
    });

    pubsub.on('logout', () => {
        AmplitudeLogger.log(EVENTS.LOGOUT, {});
        if ( onLogout && typeof onLogout === "function" ) {
            // onLogout()
            eval(`(${decodeURI(onLogout)})()`)
        }
    });

    pubsub.on('initiate_call', phone => {
        AmplitudeLogger.log(EVENTS.INIT_CALL, {phone});
        if ( onCallInitiated && typeof onCallInitiated === "function" ) {
            // onCallInitiated(phone)
            eval(`(${decodeURI(onCallInitiated)})(${phone})`)
        }
    });

    pubsub.on('call_ringing', phone => {
        AmplitudeLogger.log(EVENTS.RINGING, {phone});
        if (onInComingCall && typeof onInComingCall === "function" ) {
            eval(`(${decodeURI(onInComingCall)})(${phone})`)
        }
    })

    console.log(">>>>>>>> Pressone events initialized >>>>>>>>>")
    return null;
};
